module.exports = __webpack_public_path__ + "assets/ef4fa7a876b1cdc93e88537dcddfc9b7.mp3";